__turbopack_context__.v({
  "button": "recovery-email-sent-module-scss-module__nhTP5q__button",
  "controls": "recovery-email-sent-module-scss-module__nhTP5q__controls",
  "time": "recovery-email-sent-module-scss-module__nhTP5q__time",
});
